import {
  axiosDELETE,
  axiosGET,
  axiosPOST,
  axiosPUT,
} from 'dataLayer/api/axiosClient';

const URL_USER_PROFILE = `profile/`;
const URL_USER_PROFILE_EXERCISE = 'profile/exercise/';
const URL_USER_PROFILE_NUTRITION = 'profile/nutrition/';
const URL_DNA24_PROFILE = 'profile/assessments/rms/dna24/';
const URL_USER_GENOTYPE = 'profile/genotype/';
const URL_RECOMMENDER_EXERCISES = 'profile/recommender/exercises/';
const URL_RECOMMENDER_RECIPES = 'profile/recommender/recipes/';
const URL_RECOMMENDER_MEALPLAN = 'profile/recommender/mealplan/';
const URL_PDF_REPORT = '/profile/reports/';

export const apiGetUserProfile = async () => {
  const response = await axiosGET(URL_USER_PROFILE);
  return response.data;
};

export const apiPutUserProfile = async (data) => {
  const response = await axiosPUT(URL_USER_PROFILE, data);
  return response.data;
};

export const apiGetExercise = async () => {
  const response = await axiosGET(URL_USER_PROFILE_EXERCISE);
  return response.data;
};

export const apiPutExercise = async (data) => {
  const response = await axiosPUT(URL_USER_PROFILE_EXERCISE, data);
  return response.data;
};

export const apiGetNutrition = async () => {
  const response = await axiosGET(URL_USER_PROFILE_NUTRITION);
  return response.data;
};

export const apiPutNutrition = async (data) => {
  const response = await axiosPUT(URL_USER_PROFILE_NUTRITION, data);
  return response.data;
};

export const apiGetDna24Profile = async () => {
  const response = await axiosGET(URL_DNA24_PROFILE);
  return response.data;
};

export const apiGetGenotype = async () => {
  const response = await axiosGET(URL_USER_GENOTYPE);
  return response.data;
};

export const apiPostListReport = async (data) => {
  const response = await axiosPOST(URL_PDF_REPORT, data);
  return response.data;
};

export const apiGetPdfReport = async (reportType, lang) => {
  const response = await axiosGET(`${URL_PDF_REPORT}${reportType}/${lang}/`);
  return response.data;
};
/**
 * In case of successful request but there is no genotype data already uploaded API returns error 404.
 * Therefore we catch it and return response.
 */
export const apiGetGenotypeWithErrorCatch = async () => {
  let response;
  try {
    const getResponse = await axiosGET(URL_USER_GENOTYPE);
    response = getResponse.data;
  } catch (error) {
    response = error.response;
  }
  return response;
};

export const apiPostGenotype = async (data) => {
  const response = await axiosPOST(URL_USER_GENOTYPE, data);
  return response.data;
};

export const apiDeleteGenotype = async (data) => {
  const response = await axiosDELETE(URL_USER_GENOTYPE);
  return response.data;
};

export const apiGetRecommenderExercises = async () => {
  const response = await axiosGET(URL_RECOMMENDER_EXERCISES);
  return response.data;
};

export const apiGetRecommenderRecipes = async () => {
  const response = await axiosGET(URL_RECOMMENDER_RECIPES);
  return response.data;
};

export const apiGetRecommenderMealplan = async () => {
  const response = await axiosGET(URL_RECOMMENDER_MEALPLAN);
  return response.data;
};
